import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ProgressDialogComponent } from '../progress-dialog/progress-dialog.component';
import { UploadMetadataComponent } from './upload-metadata/upload-metadata.component';

@NgModule({
  declarations: [UploadMetadataComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ProgressDialogComponent
  ],
  exports: [UploadMetadataComponent]
})
export class MetadataIoModule {}
